'use client';

import type { ComponentType } from 'react';
import type { SignupStepId } from '../../steps';
import { EarlierAnswersGate } from '../EarlierAnswersGate';

/**
 * Wraps a wrap-up step: with a step id, the step needs every answer collected
 * before it.
 */
export function gated(Step: ComponentType, step?: SignupStepId): ComponentType {
  function GatedStep() {
    return step === undefined ? (
      <Step />
    ) : (
      <EarlierAnswersGate step={step}>
        <Step />
      </EarlierAnswersGate>
    );
  }
  return GatedStep;
}
